export const getOrCreateDeviceId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const storageKey = 'ltdan_device_id';
    let existing = window.localStorage.getItem(storageKey);

    if (existing && existing.trim().length > 0) {
      return existing;
    }

    const newId =
      window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    window.localStorage.setItem(storageKey, newId);
    return newId;
  } catch {
    return undefined;
  }
};
